import { useTranslation } from 'react-i18next';

// TODO move this styles somewhere else or duplicate here
import {
  StyledContentWrapper,
  StyledFakeInput,
  StyledFakeInputLabel,
  StyledLine,
  StyledMessage,
  StyledTextEllipsis,
} from '~/components/atoms/mockup-previews/email-mockup/styled';

import { StyledMockupWrapper } from './styled';

type SmsMockupProps = {
  number?: string;
  message?: string;
};

export const SmsMockup = ({ number, message }: SmsMockupProps) => {
  const { t } = useTranslation();

  return (
    <StyledMockupWrapper>
      <StyledContentWrapper>
        <StyledFakeInputLabel>{t('staticQrTemplates:sms:mockup:number')}</StyledFakeInputLabel>
        <StyledFakeInput>
          <StyledTextEllipsis>{number}</StyledTextEllipsis>
        </StyledFakeInput>
        <StyledFakeInputLabel>{t('staticQrTemplates:sms:mockup:message')}</StyledFakeInputLabel>
        <StyledLine />
        <StyledMessage>{message}</StyledMessage>
      </StyledContentWrapper>
    </StyledMockupWrapper>
  );
};
